<template>
  <div class="footer-component"></div>
</template>
<script>
export default {
  name: 'FooterComponent',
  props: [],
  components: {},
  data() {
    return {

    }
  },
  created() {},
  methods: {},
  mounted() {}
}

</script>
<style scoped>
.footer-component {
  width: 100%;
  height: auto;
}

</style>
